
// Type definition for gtag
declare global {
  interface Window {
    gtag: (
      type: string,
      action: string,
      params?: Record<string, any>
    ) => void;
  }
}

// Helper function to track page views
export const trackPageView = (path: string) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('config', 'G-DEC2M263SS', {
      page_path: path
    });
  }
};

// Helper function to track custom events
export const trackEvent = (
  eventName: string,
  eventParams?: Record<string, any>
) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', eventName, eventParams);
  }
};
